// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gx6CcRHVXYRCbxx0atkA {
    flex: 1;
    display: flex;
    justify-content: flex-end;
}

.DsyzwzoIMMHnOLRSXgEQ {
    width: 100%;
    position: sticky;
    display: flex;
    padding: 0 16px;
    top: 0;
    left: auto;
    right: 0;
    background-color: white;
    min-height: var(--header-height);
    max-height: var(--header-height);
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/Layout/Header/HeaderMobile/HeaderMobile.module.css"],"names":[],"mappings":"AAAA;IACI,OAAO;IACP,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,MAAM;IACN,UAAU;IACV,QAAQ;IACR,uBAAuB;IACvB,gCAAgC;IAChC,gCAAgC;AACpC","sourcesContent":[".header {\n    flex: 1;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.headerDrawer {\n    width: 100%;\n    position: sticky;\n    display: flex;\n    padding: 0 16px;\n    top: 0;\n    left: auto;\n    right: 0;\n    background-color: white;\n    min-height: var(--header-height);\n    max-height: var(--header-height);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `gx6CcRHVXYRCbxx0atkA`,
	"headerDrawer": `DsyzwzoIMMHnOLRSXgEQ`
};
export default ___CSS_LOADER_EXPORT___;
